/**
 * Created by gavin on 19/2/15.
 */
import axios from "../../utils/axios";

// 积分等级
export function getInfo(query) {
    return axios({
        url: "sysUserIntegral/getInfo",
        method: "get",
        params: query
    });
}

export function update(data) {
    return axios({
        url: "sysUserIntegral/update",
        method: "post",
        data: data
    });
}

